<template>
  <nav>

  </nav>
  <router-view/>
</template>
